import { useEffect } from 'react';
import { Route as SpaceRoute } from '@/routes/$spaceSlug/index.tsx';
import { api } from '@repo/backend/convex/_generated/api';
import { useQuery } from 'convex/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LoadingPlaceholder } from '@components/loading-placeholder.tsx';
import { SpacesPicker } from '@/components/spaces/SpacesPicker';
import { spaceParams } from '@/state/space.store';

export const Route = createFileRoute('/')({
  component: SpacesPage,
  head: () => ({
    meta: [
      {
        title: 'Findya | Spaces',
      },
    ],
  }),
});

function SpacesPage() {
  const spaces = useQuery(api.spaceFunctions.getUserSpaces, {});
  const navigate = useNavigate();

  useEffect(() => {
    if (spaces?.[0]) {
      navigate({ to: SpaceRoute.to, params: spaceParams(spaces[0]) });
    }
  }, [spaces, navigate]);

  if (!spaces || spaces?.[0]) {
    return <LoadingPlaceholder text="Checking your spaces..." />;
  }

  return <SpacesPicker spaces={spaces} />;
}
